import { Fragment, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/20/solid";
import brands from "../public/brands.json";
import { useFormContext } from "react-hook-form";
import { classNames } from "../utils/formatters";
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";

type Brand = {
  name: string;
};

export default function BrandSelect({ value, onChange, disabled }) {
  const { formState } = useFormContext(); // retrieve all hook methods
  const { errors } = formState;

  // const [selected, setSelected] = useState(null);
  const [query, setQuery] = useState("");
  const selected = value;

  const filteredBrands =
    query === ""
      ? brands
      : brands.filter((brand) =>
          brand.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  return (
    <div className="">
      <label
        htmlFor="brand"
        className="block text-sm font-medium text-gray-700"
      >
        Marca
      </label>
      <Combobox value={selected} onChange={onChange} disabled={disabled}>
        <div className="relative mt-1">
          <div
            className={classNames(
              "relative w-full cursor-default overflow-hidden rounded-md shadow-sm focus:ring-orange-500 focus:border-orange-500 block border border-gray-300 sm:text-sm",
              errors.brand
                ? "ring-2 ring-red-500 ring-offset-2 ring-offset-white"
                : ""
            )}
          >
            <Combobox.Button as="div">
              <Combobox.Input
                className={classNames(
                  "w-full border-none py-2 pl-3 pr-10 text-input leading-5 text-gray-900 focus:ring-0 capitalize",
                  disabled ? "bg-gray-100" : ""
                )}
                displayValue={(brand) =>
                  (brand as Brand)?.name.toLowerCase() || ""
                }
                onChange={(event) => setQuery(event.target.value)}
              />
              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </Combobox.Button>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10">
              {filteredBrands.length === 0 && query !== "" ? (
                <Combobox.Option
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 px-4 ${
                      active ? "bg-orange-500 text-white" : "text-gray-900"
                    }`
                  }
                  value={{ id: null, name: query }}
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={`block truncate capitalize ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        Agregar: {query.toLowerCase()}
                      </span>
                      {selected ? (
                        <span
                          className={`absolute inset-y-0 right-0 flex items-center pr-3 ${
                            active ? "text-white" : "text-orange-500"
                          }`}
                        >
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Combobox.Option>
              ) : (
                filteredBrands.map((brand) => (
                  <Combobox.Option
                    key={brand.name}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 px-4 ${
                        active ? "bg-orange-500 text-white" : "text-gray-900"
                      }`
                    }
                    value={brand}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate capitalize ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {brand.name.toLowerCase()}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 right-0 flex items-center pr-3 ${
                              active ? "text-white" : "text-orange-500"
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}
